import React, { useEffect } from "react";
import Hero from "components/hero/Hero.js";
import Footer from "components/footers/FiveColumnDark";
import ItServiceDetails from "components/cards/Services";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import GlobalStyle from "helpers/GlobalStyle";
import useScreenSize from "helpers/useScreenSize";

export default () => {
  const sectionId = window.location.hash;
  const { isXs } = useScreenSize();

  useEffect(() => {
    // Scroll to the specific section after the component mounts
    const section = document.getElementById(sectionId.substring(1));
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  }, [sectionId]);

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <ItServiceDetails isXs={isXs} />
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
